function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const SortNumericAscIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 12V0H3v12H.5L4 15.5 7.5 12H5zM13.5 7a.5.5 0 0 1-.5-.5V1h-.5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5zM14.5 9h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5H14v2h-2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5zM12 10h2v2h-2v-2z"
  }));
};
export default SortNumericAscIcon;